import type { TourSection } from './types';

export const productsListSections: TourSection[] = [
  {
    id: 'filters',
    label: 'Buscar y filtrar',
    steps: [
      {
        target: '[data-tour="products-filters"]',
        title: 'Filtros del listado',
        content:
          'Busca por código SKU, nombre, slug o código NPF — encuentra cualquiera de esos. Puedes combinar con marca, categoría, estado, organización, grupo de posición y estado del material. Por defecto muestra los activos y activos en ecommerce. Mientras haya una búsqueda escrita, esos dos estados no se aplican, para que encuentres el producto aunque esté inactivo. Lo que filtres queda guardado en la dirección del navegador, así puedes compartir el link.',
        placement: 'bottom',
      },
    ],
  },
  {
    id: 'incomplete-toggle',
    label: 'Solo productos incompletos',
    steps: [
      {
        target: '[data-tour="products-only-incomplete"]',
        title: 'Mostrar solo incompletos',
        content:
          'Activa esta casilla para ver únicamente los productos que tienen algún dato faltante: sin nombre, sin marca, sin categoría o sin imagen. Es el mismo conjunto que aparece en la sección Pendientes.',
      },
    ],
  },
  {
    id: 'table',
    label: 'Tabla de productos',
    steps: [
      {
        target: '[data-tour="products-table"]',
        title: 'Listado',
        content:
          'Click en el SKU para abrir y editar un producto. La columna Estado resume si está completo o qué le falta. La columna Imagen muestra la principal del producto.',
        placement: 'top',
      },
    ],
  },
  {
    id: 'pagination',
    label: 'Navegar entre páginas',
    steps: [
      {
        target: '[data-tour="products-pagination"]',
        title: 'Paginación',
        content:
          'Anterior y Siguiente recorren las páginas. El total mostrado tiene en cuenta los filtros aplicados, no el catálogo completo.',
      },
    ],
  },
];
